import { mqTabletLandscape } from './mq';

export const megaMenu = {
  all: document.querySelectorAll('.mega-menu--any'),
  header: document.querySelector('.header'),
  overlay: document.querySelector('.mega-menu-overlay'),
  initiated: false,
  classes: {
    megaMenu: 'mega-menu--any',
    hasVisibleMegaMenu: 'has-visible-mega-menu',
    headerMenuItemButton: 'header-menu__item-button',
    isMegaMenuVisible: 'is-mega-menu-visible',
  },

  init: function () {
    // Close mega menu when clicked outside its area
    document.body.addEventListener('click', (e) => {
      if (this.isVisible()) {
        let el = e.target;

        do {
          if (
            el.classList.contains(this.classes.megaMenu) ||
            el.classList.contains(this.classes.headerMenuItemButton)
          ) {
            return;
          }

          el = el.parentElement;
        } while (el.parentElement);

        this.hide();
      }
    });

    // Bind Escape key
    document.addEventListener('keydown', (e) => {
      if (e.code === 'Escape' && this.isVisible()) {
        document.activeElement.blur();
        this.hide();
      }
    });

    // Bind all close buttons
    this.all.forEach((megaMenu) => {
      megaMenu.querySelectorAll('.mega-menu__close').forEach((button) => {
        button.addEventListener('click', () => this.hide());
      });
    });

    // Update overlay height on window resize
    window.addEventListener('resize', () => {
      if (this.isVisible()) {
        this.updateOverlayHeight();
      }
    });

    // Hide in mobile layout
    mqTabletLandscape.addListener((e) => {
      if (e.matches) {
        this.hide();
      }
    });

    // Set as initiated
    this.initiated = true;
  },

  show: function (el) {
    this.hide();

    el.parentElement.classList.add(this.classes.hasVisibleMegaMenu);
    this.updateOverlayHeight();
    document.documentElement.classList.add(this.classes.isMegaMenuVisible);
    document.body.classList.add(this.classes.isMegaMenuVisible);

    if (this.header.classList.contains('is-header-menu-dark')) {
      this.header.classList.add('has-dark-background');
    }

    if (!this.initiated) {
      this.init();
    }
  },

  hide: function () {
    this.all.forEach((menu) => menu.parentElement.classList.remove(this.classes.hasVisibleMegaMenu));
    document.documentElement.classList.remove(this.classes.isMegaMenuVisible);
    document.body.classList.remove(this.classes.isMegaMenuVisible);
    this.header.classList.remove('has-dark-background');
  },

  toggle: function (el) {
    if (el.parentElement.classList.contains(this.classes.hasVisibleMegaMenu)) {
      this.hide();
    } else {
      this.show(el);
    }
  },

  isVisible: function () {
    return document.body.classList.contains(this.classes.isMegaMenuVisible);
  },

  getVisible: function () {
    return Array.from(this.all).find((menu) => menu.parentElement.classList.contains(this.classes.hasVisibleMegaMenu));
  },

  updateOverlayHeight: function () {
    const visibleMenu = this.getVisible();

    if (visibleMenu) {
      this.overlay.style.height = visibleMenu.offsetHeight + 'px';
    }
  },
};